import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, forkJoin} from 'rxjs';
import {map} from 'rxjs/operators';
import {Collection} from './collection.model';
import urlJoin from 'url-join';
import {CustomerBankAccountService} from './customer-bank-account.service';
import * as _ from 'lodash';
import { DashboardFilters } from '../components/dashboard/filters/dashboard-filters.model';
import { PayrollCycleType, PayrollTypeInfo } from './payroll-types.service';
import { FeatureToggleService } from '../shared/services/feature-toggle/feature-toggle.service';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class CollectionService {

  constructor(
    private http: HttpClient,
    private bankAccountService: CustomerBankAccountService,
    private productConfigService: FeatureToggleService) {
  }

  getCollections(tenantId: string, filters: DashboardFilters): Observable<Collection[]> {
    return forkJoin([
      this.http.get<Collection[]>(
        urlJoin(this._getUri('', tenantId, this._getQueryParameters(filters))),
        {headers: {}}),
        this.bankAccountService.getBankAccounts(tenantId)
    ]).pipe(
      map((results) => {
        const collections = results[0];
        const bankAccounts = results[1];
        const result = collections.map(coll => {
          if (!coll.hasOwnProperty('includedNettedAmount')) {
            coll.includedNettedAmount = coll.totalAmount;
            coll.excludedNettedAmount = 0;
            coll.achCreditRefundedAmount = 0;
            coll.nettedCollectionCount = 0;
          }

          coll.totalNettedAmount = coll.includedNettedAmount + coll.excludedNettedAmount + coll.achCreditRefundedAmount;
          coll.maskedAccountNumber = this.getMaskedAccountNumber(coll, bankAccounts);
          return coll;
        });
        return result;
      })
    );
  }

  get isApiForNettedCollectionsEnabled(): boolean  {
    return this.productConfigService.isFeatureEnabled('enableApiForNettedCollections');
  }

  private getMaskedAccountNumber(coll: Collection, accounts: any[]) {
    const account = _.find(accounts, (acct) => acct.bankAccountId === coll.customerBankAccountId);
    return account ? account.maskedAccountNumber : '';
  }

  private _getUri(path: string, tenantId: string, params: string) {
    const ctrlr = this.isApiForNettedCollectionsEnabled ? `cui-payment` : `payment`;
    let uri = urlJoin(ROUTE_TOKEN_GATEWAY_URL, `${ctrlr}/v1/tenants/${encodeURI(tenantId)}/collections/collectionsForPayroll`);
    uri = urlJoin(uri, path);
    if (params) {
      uri += '?' + params;
    }
    return uri;
  }

  private _getQueryParameters(filters: DashboardFilters): string {
    let parameters =  new HttpParams()
      .append('payUtcDate', filters.payDate.startOf('day').format())
      .append('payUtcToDate', filters.payDate.endOf('day').format());

    if (filters.payrollType !== PayrollCycleType.All) {
      new PayrollTypeInfo(filters.payrollType).paySequences.forEach(runNumber => {
        parameters = parameters.append('paySequenceNumbers', String(runNumber));
      });
    }

    filters.payGroups.forEach(paygroup => {
      parameters = parameters.append('payGroups', paygroup.name);
    });

    filters.products.forEach(product => {
      parameters = parameters.append('productCodes', product.toString());
    });

    return parameters.toString();
  }
}
